<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Werbemittel erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.banners.store'))">
                <form-fields :form="form" :zones="zones" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'zones',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    description: null,
                    js_code: null,
                    css_code: null,
                    html_code: null,
                    zones: [],
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>